import React from "react";
import styles from "./InsufficientData.module.scss";
import { IoMdCalendar } from "react-icons/io";

function InsufficientData() {
  return (
    <div className={styles.container}>
      <div className={styles.contentContainer}>
        <div className={styles.calendar}>
          <IoMdCalendar className={styles.calendarIcon} />
        </div>
        <div className={styles.headingText}>
          No Data Available for This Date Range!
        </div>
        <div className={styles.paragraphText}>
          Try selecting another date range.
        </div>
      </div>
    </div>
  );
}

export default InsufficientData;
